import { ApiDataObject, RegiterFormData, UserFormData } from "interface/interface";
import { TOKEN_DATA_TYPE } from "enum/enums";
import UseApiService from "./apiService";
import { API_END_POINTS } from "lib/Constants";

export const authenticateUser = (email: string, appUrl: string):Promise<any> => {
  const body = {
    url: API_END_POINTS.AUTHORIZE_USER,
    data: {
      email,
      appUrl: `${window.location.origin}${appUrl}`,
    },
  };
  return UseApiService().post(body);
};

export const registerUser = (data: UserFormData) :Promise<any>=> {
  const body = {
    url: API_END_POINTS.REGISTER_CUSTOMER,
    data,
  };
  return UseApiService().post(body);
};
export const verifyUser = (token: string) => {
  const body = {
    url: API_END_POINTS.AUTH_CALLBACK,
    data: {
      token,
    },
  };
  return UseApiService().get(body);
};

export const getCustomersList = (tenantId:string) => {
  const body = {
    url: `/tenants/${tenantId}${API_END_POINTS.CUSTOMER}`,
    headerToken: TOKEN_DATA_TYPE.ACCESS,
  };
  return UseApiService().get(body);
};

export const getToken = (store_url: string) => {
  const body = {
    url: API_END_POINTS.INTERNAL_AUTH,
    data: {
      store_url,
    },
    headerToken: TOKEN_DATA_TYPE.INTERNAL,
  };
  return UseApiService().post(body);
};

export const customerOnboarding = (store_url: string, onboarded: boolean) => {
  const body = {
    url: API_END_POINTS.CUSTOMER + API_END_POINTS.ONBOARD,
    data: { store_url, onboarded },
    headerToken: TOKEN_DATA_TYPE.ACCESS,
  };
  return UseApiService().post(body);
};
export const customerInternal = ({data,requestType="post",tenantId}:{data:RegiterFormData,requestType?:string,tenantId:string}) => {
  const body = {
    url:`/tenants/${tenantId}${API_END_POINTS.CUSTOMER}`,
    data,
    headerToken: TOKEN_DATA_TYPE.ACCESS,
  };
  return requestType === "post" ? UseApiService().post(body) : UseApiService().patch(body);
};
export const checkAppInstall = (store_url:string) => {
  const body: ApiDataObject = {
    url: `${API_END_POINTS.CUSTOMER_APP_INSTALL}`,
    headerToken: TOKEN_DATA_TYPE.ACCESS,
    data: {
      store_url
    },
  };

  return UseApiService().get(body);
}

export const UpdateRegisterUser = (data: UserFormData) :Promise<any>=> {
  const body = {
    url: API_END_POINTS.REGISTER_CUSTOMER,
    data,
  };
  return UseApiService().patch(body);
};
export const getUserDetails=()=>{
       const body ={
        url:API_END_POINTS.User.userProfile,
        headerToken: TOKEN_DATA_TYPE.ACCESS,
       }
       return UseApiService().get(body)
}

